import React from 'react'
import {Modal} from 'react-bootstrap'
import Button from 'app/components/Button'
import { useNavigate } from 'react-router-dom'

interface ConnectCloudModalProps {
  show: boolean
  onClose: () => void
}

const ConnectCloudModal: React.FC<ConnectCloudModalProps> = ({show, onClose}) => {
  const navigate = useNavigate()

  const handleGoogleCloudClick = () => {
    navigate('/vulnerabilities/clouds/gcp/configuration')
    onClose()
  }

  return (
    <Modal show={show} onHide={onClose} centered dialogClassName="">
      <Modal.Header closeButton className='border-0 px-8 pb-2'>
        <Modal.Title className='fw-bold fs-2 text-gray-900'>Let's connect a cloud!</Modal.Title>
      </Modal.Header>
      <Modal.Body style={{padding: '24px', paddingTop: '5px', paddingBottom: '20px'}}>
        <div className='mb-4'>
          <p className='text-gray-900 fs-6'>
          There are five steps to connect your cloud. We will guide you through each step. To begin, please select the cloud provider you wish to connect.
          </p>
        </div>

        <div className='d-grid gap-4 mb-4'>
          <Button
            btnType='primary'
            onClick={handleGoogleCloudClick}
            className='p-4 d-flex align-items-center justify-content-center'
          >
            <div className='d-flex align-items-center'>
              <div className='me-3'>
              <img src='/integrations/gcp.svg' alt='Google Cloud Platform' width={16} height={16} />
              </div>
              <span className='fw-semibold fs-6'>Google Cloud Platform</span>
            </div>
          </Button>

          <Button
            btnType='default'
            disabled
            className='p-4 d-flex align-items-center justify-content-center position-relative gap-3'
          >
            <div className='d-flex align-items-center'>
              <div className='me-3'>
                <img src='/integrations/aws.svg' alt='Amazon Web Services' width={16} height={16} />
              </div>
              <span className='fw-semibold fs-6 text-gray-900'>Amazon Web Services</span>
            </div>
            <span className='badge bg-secondary fs-8'>Enterprise</span>
          </Button>

          <Button
            btnType='default'
            disabled
            className='p-4 d-flex align-items-center justify-content-center position-relative gap-3'
          >
            <div className='d-flex align-items-center'>
              <div className='me-3'>
              <img src='/integrations/azure.svg' alt='Microsoft Azure Cloud' width={16} height={16} />
              </div>
              <span className='fw-semibold fs-6 text-gray-900'>Microsoft Azure Cloud</span>
            </div>
            <span className='badge bg-secondary fs-8'>Enterprise</span>
          </Button>

          <Button
            btnType='default'
            disabled
            className='p-4 d-flex align-items-center justify-content-center position-relative gap-3'
          >
            <div className='d-flex align-items-center '>
              <div className='me-3'>
              <img src='/integrations/Digital-Ocean.svg' alt='Digital Ocean' width={16} height={16} />
              </div>
              <span className='fw-semibold fs-6 text-gray-900'>Digital Ocean</span>
            </div>
            <span className='badge bg-secondary text-gray-900 fs-8'>Enterprise</span>
          </Button>
        </div>

      </Modal.Body>
    </Modal>
  )
}

export default ConnectCloudModal
